import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { zipCode, personCompany } from '../../Helpers/validators';
import { normalizeZip } from '../../Helpers/normalizers';
import RenterField from './RenterField';
import CompanyTypeField from './CompanyTypeField';
import JointVentureField from './JointVentureField';
import StateField, { usStatePropType } from './StateField';
import CountryField from './CountryField';
import { TextInput, Button } from '@jauntin/react-ui';
import { validators } from '@jauntin/utilities';
const { required } = validators;

const Edit = ({
  confirm,
  show,
  valid,
  insuredRenter,
  usStates,
  insuranceContactRef,
  scrollToPosition,
  insuredCompanyType,
}) =>
  show && (
    <>
      <RenterField name="insuredRenter" validate={[personCompany]} />
      {!insuredRenter && (
        <div id="insuredIndividual" className="form-row">
          <Field
            component={TextInput}
            validate={[required]}
            name="insuredFirstName"
            label="First Name"
            ariaLabel="First Name"
            placeholder="First Name"
            wrapperClassName="col-sm"
            inputClassName="form-control-lg"
          />
          <Field
            component={TextInput}
            validate={[required]}
            name="insuredLastName"
            label="Last Name"
            ariaLabel="Last Name"
            placeholder="Last Name"
            wrapperClassName="col-sm"
            inputClassName="form-control-lg"
          />
        </div>
      )}
      {insuredRenter && (
        <div id="insuredCompanyGroup">
          <div className="row">
            <Field
              component={TextInput}
              validate={[required]}
              name="insuredCompany"
              label="Company name"
              ariaLabel="Company name"
              placeholder="Company name"
              wrapperClassName="col-sm"
              inputClassName="form-control-lg"
            />
          </div>
          <div className="row">
            <Field
              component={CompanyTypeField}
              validate={[required]}
              name="insuredCompanyType"
              type="text"
            />
            {insuredCompanyType === 'jointVenture' && (
              <JointVentureField
                name="jointVentureType"
                validate={[required]}
              />
            )}
          </div>
        </div>
      )}
      <Field
        component={TextInput}
        validate={[required]}
        name="insuredAddress"
        label="Street Address"
        ariaLabel="Address"
        placeholder="Address"
        subtext="Mailing address, including apartment, suite, unit, building, floor, etc.."
        inputClassName="form-control-lg"
      />
      <div className="form-row">
        <Field
          component={TextInput}
          validate={[required]}
          name="insuredCity"
          label="City"
          ariaLabel="City"
          placeholder="City"
          wrapperClassName="col-sm"
          inputClassName="form-control-lg"
        />
        <Field
          component={StateField}
          validate={[required]}
          name="insuredState"
          type="select"
          usStates={usStates}
        />
        <Field
          component={TextInput}
          validate={[required, zipCode]}
          normalize={normalizeZip}
          name="insuredZip"
          label="Zipcode"
          ariaLabel="Zipcode"
          placeholder="Zipcode"
          pattern="\d*"
          inputMode="numeric"
          wrapperClassName="col-sm"
          inputClassName="form-control-lg"
        />
      </div>
      <div className="form-row" hidden>
        <Field
          component={CountryField}
          validate={[required]}
          name="insuredCountry"
          type="select"
          input={{ disabled: true }}
        />
      </div>
      <hr />
      <div className="float-right">
        <Button
          disabled={!valid}
          onClick={() => {
            confirm();
            scrollToPosition(insuranceContactRef);
          }}
          text="Confirm Insured"
          className="btn-primary"
        />
      </div>
    </>
  );
Edit.propTypes = {
  confirm: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  insuredRenter: PropTypes.bool.isRequired,
  usStates: usStatePropType.isRequired,
  scrollToPosition: PropTypes.func.isRequired,
  insuranceContactRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  insuredCompanyType: PropTypes.string.isRequired,
};

export default Edit;
